import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Chip,
  Dialog,
  TextField,
  IconButton,
  Tooltip,
  Autocomplete,
} from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";

export default function FilterSearch(props) {
  const [open, setOpen] = React.useState(false);
  const [isActiveState, setIsActiveState] = useState(null);
  const [searchState, setSearchState] = useState([]);
  const [add, setAdd] = useState("");

  const States = [
    { id: 3, label: "همه" },
    { id: 1, label: "فعال" },
    { id: 2, label: "غیر فعال" },
  ];

  useEffect(() => {
    if (!props.isActiveState) {
      setIsActiveState("");
    }
  }, [props]);

  return (
    <Box
      sx={{
        gap: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
        width: "100%",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle1">فیلتر وضعیت : </Typography>
        <Tooltip title="افزودن">
          <IconButton onClick={() => setOpen(true)}>
            <AddCircleIcon
              sx={{
                color: "primary.main",
              }}
            />
          </IconButton>
        </Tooltip>
        <Box
          style={{ direction: "ltr", display: "flex", alignItems: "center" }}
        >
          {props.isActiveState && (
            <Chip
              label={States.find((m) => m.id == props.isActiveState)?.label}
              onDelete={(data) => {
                props.setIsActiveState("");
                setIsActiveState("");
              }}
              color="primary"
              sx={{
                px: 2,
                m: 0.5,
                "& .MuiChip-label	": {
                  px: 0,
                },
              }}
            />
          )}
        </Box>
      </Box>
      <Dialog
        maxWidth="sm"
        fullWidth
        onClose={() => setOpen(false)}
        open={open}
      >
        <Box
          sx={{ m: 3, my: 5 }}
          display="grid"
          gridTemplateColumns="repeat(12, 1fr)"
          gap={3}
        >
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center" }}
          >
            <Autocomplete
              size="small"
              value={isActiveState ? isActiveState : ""}
              onChange={(event, newValue) => {
                if (newValue && newValue == 3) {
                  setIsActiveState("");
                } else if (newValue) {
                  setIsActiveState(newValue);
                } else {
                  setIsActiveState("");
                }
              }}
              fullWidth
              sx={{ width: "50%" }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              getOptionLabel={(option) => {
                if (option) {
                  return States.find((m) => m.id == option).label;
                }
                return "";
              }}
              options={States ? States.map((m) => m.id) : []}
              renderInput={(params) => (
                <TextField variant="outlined" {...params} label="وضعیت" />
              )}
            />
          </Box>

          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "center", mx: "auto" }}
          >
            <Button
              variant="contained"
              onClick={() => {
                props.setIsActiveState(isActiveState);
                setOpen(false);
              }}
              sx={{ width: "70px", mr: 2 }}
            >
              ثبت
            </Button>
            <Button
              variant="outlined"
              onClick={() => {
                setOpen(false);
              }}
              sx={{ width: "70px" }}
            >
              انصراف
            </Button>
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
}
